module.exports = __webpack_public_path__ + "img/cadillac.39a5266e.png";